import { createStandardTableReducer } from 'utils';

import { NAME } from './constants';

const { actionTypes, actions, selectors, reducer } = createStandardTableReducer(NAME, null);

export { actionTypes, actions, selectors };

export default reducer;
